<template><slot /></template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { watch } from 'vue'

import { myomrApolloClient } from '@/plugins/vue-apollo'
import { useLocaleStore } from '@/stores'

const localeStore = storeToRefs(useLocaleStore())

watch(
  () => localeStore.locale.value,
  () => {
    myomrApolloClient.reFetchObservableQueries()
  },
)
</script>
